import React, { useRef } from 'react'
import { Modal } from 'react-bootstrap'
import { ButtonWithLoadingState } from '../Buttons'
import AssetSelect from './AssetSelect'
import { t } from 'i18next'
import styled from 'styled-components'
const StyledWrapper = styled.div`
  margin-bottom: 30px;
 
`
const AssetSelectModal = ({ selectedAssets, setSelectedAssets, handleSave, hideAssets, handleSaveIsLoading, setShowAddAssetsModal, singleSelection}) => {
  const listRef = useRef(null)
  const handleClose = () => {
    setShowAddAssetsModal(false)
  }
  return (
    <Modal size="lg" centered show={true} onHide={handleClose} scrollable>
      <Modal.Header closeButton className="pb-0">
        <Modal.Title>
          <div>
            <p className="m-0 pt-2">{t('asset_select')}</p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body ref={listRef}>
        <StyledWrapper>
          <AssetSelect selectedAssets={selectedAssets} setSelectedAssets={setSelectedAssets} hideAssets={hideAssets} listRef={listRef} singleSelection={singleSelection}/>
        </StyledWrapper>
      </Modal.Body>
      <Modal.Footer>
        <ButtonWithLoadingState
          variant='primary'
          buttonText={`${t('saveButton')} ${selectedAssets.length ? `(${selectedAssets.length})` : ''}`}
          isLoading={handleSaveIsLoading}
          onClick={handleSave}
        />
      </Modal.Footer>
    </Modal >
  )
}

export default AssetSelectModal